<template>
    <div>
        <CRow> 
            <CCol md="12" v-if="type == 'administrator' || type == 'superadmin'">   
                <CButton :color="menu == 'freelancers' ? 'info' : 'secondary'" size="sm" @click="menu != 'freelancers' ? showFreelancers() : '';" style="margin-right: 5px;">Promotores</CButton>
                <CButton :color="menu == 'available' ? 'info' : 'secondary'" size="sm" @click="menu != 'available' ? showVisits('available') : '';" style="margin-right: 5px;">Disponibles</CButton>
                <CButton :color="menu == 'locked' ? 'info' : 'secondary'" size="sm" @click="menu != 'locked' ? showVisits('locked') : '';" style="margin-right: 5px;">En Curso</CButton>
                <CButton :color="menu == 'limbo' ? 'info' : 'secondary'" size="sm" @click="menu != 'limbo' ? showVisits('limbo') : '';" style="margin-right: 5px;">Limbo</CButton>
                <CButton :color="menu == 'completed' ? 'info' : 'secondary'" size="sm" @click="menu != 'completed' ? showVisits('completed') : '';" style="margin-right: 5px;">Completadas</CButton>
                <CButton :color="menu == 'rejected' ? 'info' : 'secondary'" size="sm" @click="menu != 'rejected' ? showVisits('rejected') : '';" style="margin-right: 5px;">Rechazadas</CButton>
                <CButton :color="menu == 'accepted' ? 'info' : 'secondary'" size="sm" @click="menu != 'accepted' ? showVisits('accepted') : '';" style="margin-right: 5px;">Por Pagar</CButton>
                <CButton :color="menu == 'paid' ? 'info' : 'secondary'" size="sm" @click="menu != 'paid' ? showVisits('paid') : '';" style="margin-right: 5px;">Pagadas</CButton>
                <CButton :color="menu == 'tabulator' ? 'info' : 'secondary'" size="sm" @click="showTabulator()" style="margin-right: 5px;">Tabulador</CButton>
                <CButton color="success" size="sm" @click="showImporter();" style="float: right;">Importador de Visitas</CButton>
            </CCol>
            <CCol md="12" v-if="type == 'kam' || type == 'support'">   
                <CButton :color="menu == 'completed' ? 'info' : 'secondary'" size="sm" @click="menu != 'completed' ? showVisits('completed') : '';" style="margin-right: 5px;">Validar Visitas</CButton>
                <CButton :color="menu == 'rejected' ? 'info' : 'secondary'" size="sm" @click="menu != 'rejected' ? showVisits('rejected') : '';" style="margin-right: 5px;">Visitas Rechazadas</CButton>
                <CButton :color="menu == 'accepted' ? 'info' : 'secondary'" size="sm" @click="menu != 'accepted' ? showVisits('accepted') : '';" style="margin-right: 5px;">Visitas Aceptadas</CButton>
            </CCol>    
        </CRow>
    </div>
</template>

<script>

export default {
    name: 'GraphsMenu',
    props: {
        menu: {
            type: String,
            default() {
                return ""
            }
        },
        type: {
            type: String,
            default() {
                return "administrator"
            }
        },
    },
    components : {
	},
    data: function () {
		return {
            items: {},
            root: "",
        }
    },
    computed: {
        
    },
    methods: {
        showFreelancers: async function(){
            window.location = '/#/freelancers';
        },
        showVisits: async function(tab){
            window.location = '/#/freelance-visits/'+tab;
        },
        showAvailableVisits: async function(){
            window.location = '/#/freelance-visits/available';
        },
        showCompletedVisits: async function(){
            window.location = '/#/freelance-visits/completed';
        },
        showFinishedVisits: async function(){
            window.location = '/#/freelance-visits/paid';
        },
        showImporter: async function(){
            let location = window.location+"";
            if(location.indexOf('/#/freelance-visits/importer') == -1){
                window.location = '/#/freelance-visits/importer';
            }
            else{
                this.$router.go(0);
            }
        },
        showTabulator: async function(){
            window.location = '/#/freelance-visits/tabulator';
        },
    },
  	mounted: async function(){        
    },
}

</script>
